module.exports = __webpack_public_path__ + "img/mobile-4.827f4a07.png";